import { jsx, jsxs } from 'react/jsx-runtime';
import { forwardRef, useCallback, useMemo } from 'react';
import { Input } from '../../Input/Input.es.js';

const DatePickerInner = /*#__PURE__*/ forwardRef(({ intent, error, label, labelSuffix, display, message, placeholder, disabled, isClearable, fieldRef, clearButtonRef, value, handleClearDate, onClick, locale, ...rest }, ref)=>{
    const setRef = useCallback((e)=>{
        // Set react-hook-form ref
        if (typeof fieldRef === 'function') {
            fieldRef(e);
        } else if (fieldRef !== null) {
            fieldRef.current = e;
        }
        // Set input ref provided by react date picker
        if (typeof ref === 'function') {
            ref(e);
        } else if (ref !== null) {
            ref.current = e;
        }
    }, [
        ref,
        fieldRef
    ]);
    const localeWithFallback = useMemo(()=>({
            clear: 'Clear',
            ...locale
        }), [
        locale
    ]);
    return jsx(Input, {
        className: "date-picker-input",
        disabled: disabled,
        display: display,
        emphasize: intent === 'filter',
        error: error,
        label: label,
        labelSuffix: labelSuffix,
        message: message,
        placeholder: placeholder,
        value: value,
        children: jsxs(Input.Field.Text, {
            ref: setRef,
            "data-testid": "date-input",
            onContainerClick: onClick,
            value: value,
            ...rest,
            children: [
                isClearable && jsx(Input.Inline.IconButton, {
                    ref: clearButtonRef,
                    align: "right",
                    label: localeWithFallback.clear,
                    name: "XCircleSolid",
                    onClick: handleClearDate
                }),
                jsx(Input.Inline.Icon, {
                    align: "right",
                    name: "CalendarOutline",
                    size: 18
                })
            ]
        })
    });
});
DatePickerInner.displayName = 'MoneyInput.Inner';

export { DatePickerInner, DatePickerInner as default };
//# sourceMappingURL=DatePicker.Inner.es.js.map
